<template>
  <div
    :class="{ 'rt-card-shadow': shadow }"
    class="rt-card"
    :style="computedStyle"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'RtCard',

  props: {
    shadow: {
      type: Boolean,
      default: true
    },
    marginBottom: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    computedStyle () {
      let style = {};

      if (this.marginBottom !== undefined) {
        style['marginBottom'] = this.marginBottom;
      }

      return style;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtCard.vue?46eab11e